'use client'

import type { ReactNode } from 'react'

interface FeaturePageLayoutProps {
  children?: ReactNode
}

export function FeaturePageLayout({ children }: FeaturePageLayoutProps) {
  return (
    <div className="container mx-auto px-4 py-16 sm:py-24">
      <div className="space-y-12 sm:space-y-16">{children}</div>
    </div>
  )
}
